export const UserGuideIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.90274 5.8405C6.06531 5.37835 6.3862 4.98865 6.80857 4.74042C7.23094 4.49218 7.72753 4.40145 8.21039 4.48427C8.69325 4.56709 9.13122 4.81813 9.44673 5.19293C9.76223 5.56773 9.93491 6.04209 9.93418 6.532C9.93418 7.915 7.85968 8.6065 7.85968 8.6065M7.915 11.3725H7.92192M14.83 7.915C14.83 11.734 11.734 14.83 7.915 14.83C4.09595 14.83 1 11.734 1 7.915C1 4.09595 4.09595 1 7.915 1C11.734 1 14.83 4.09595 14.83 7.915Z"
      stroke="#686868"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
